interface Translation {
  firstParagraph: string;
  interviewTerms: string;
  privacyPolicy: string;
  translatePickLanguage: string;
  letsGo: string;
  consentText: string;
}

// eslint-disable-next-line import/prefer-default-export
export const translations: Record<string, Translation> = {
  af: {
    firstParagraph: 'Ek aanvaar {interviewTerms} en {privacyPolicy}',
    interviewTerms: 'Onderhoudsvoorwaardes',
    privacyPolicy: 'Privaatheidsbeleid',
    translatePickLanguage: 'Kies jou taal, en dan begin ons.',
    letsGo: 'Kom ons begin',
    consentText: `## Welkom!
Dit is nie 'n tipiese opname nie.

Dit is 'n interaktiewe KI-onderhoud, ontwerp om jou unieke perspektief te hoor.
`,
  },
  am: {
    firstParagraph: 'እኔ {interviewTerms} እና {privacyPolicy} ተቀብያለሁ',
    interviewTerms: 'የቃለ መጠይቅ ውሎች',
    privacyPolicy: 'የግላዊነት ፖሊሲ',
    translatePickLanguage: 'ቋንቋዎን ይምረጡ፣ ከዚያ እንጀምራለን።',
    letsGo: 'እንጀምር',
    consentText: `## እንኳን ደህና መጡ!
ይህ ተራ የዳሰሳ ጥናት አይደለም።

ይህ ልዩ አመለካከትዎን ለመስማት የተነደፈ መስተጋብራዊ AI ቃለ መጠይቅ ነው።
`,
  },
  ar: {
    firstParagraph: 'أوافق على {interviewTerms} و {privacyPolicy}',
    interviewTerms: 'شروط المقابلة',
    privacyPolicy: 'سياسة الخصوصية',
    translatePickLanguage: 'اختر لغتك، ثم سنبدأ.',
    letsGo: 'لنبدأ',
    consentText: `## مرحبًا!
هذه ليست استطلاعًا عاديًا.  

إنها مقابلة تفاعلية بالذكاء الاصطناعي، صُممت للاستماع إلى وجهة نظرك الفريدة.
`,
  },
  hy: {
    firstParagraph: 'Ես համաձայն եմ {interviewTerms} և {privacyPolicy}',
    interviewTerms: 'Հարցազրույցի պայմաններ',
    privacyPolicy: 'Գաղտնիության քաղաքականություն',
    translatePickLanguage: 'Ընտրեք ձեր լեզուն, և ապա մենք կսկսենք։',
    letsGo: 'Սկսենք',
    consentText: `## Բարի գալուստ!
Սա սովորական հարցում չէ։  

Սա ինտերակտիվ արհեստական բանականության հարցազրույց է, որը նախատեսված է լսելու ձեր եզակի տեսանկյունը։
`,
  },
  az: {
    firstParagraph: 'Mən {interviewTerms} və {privacyPolicy} ilə razıyam',
    interviewTerms: 'Müsahibə şərtləri',
    privacyPolicy: 'Məxfilik Siyasəti',
    translatePickLanguage: 'Dilinizi seçin, sonra başlayırıq.',
    letsGo: 'Başlayaq',
    consentText: `## Xoş gəlmisiniz!
Bu adi bir sorğu deyil.  

Bu sizin unikal baxış bucağınızı eşitmək üçün nəzərdə tutulmuş interaktiv süni intellekt müsahibəsidir.
`,
  },
  be: {
    firstParagraph: 'Я прымаю {interviewTerms} і {privacyPolicy}',
    interviewTerms: "Умовы інтэрв'ю",
    privacyPolicy: 'Палітыка прыватнасці',
    translatePickLanguage: 'Абярыце сваю мову, і тады мы пачнем.',
    letsGo: 'Пачнем',
    consentText: `## Сардэчна запрашаем!
Гэта не звычайны апытанне.  

Гэта інтэрактыўнае інтэрв’ю з штучным інтэлектам, створанае, каб пачуць ваш унікальны погляд.
`,
  },
  bs: {
    firstParagraph: 'Prihvatam {interviewTerms} i {privacyPolicy}',
    interviewTerms: 'Uvjeti intervjua',
    privacyPolicy: 'Politika privatnosti',
    translatePickLanguage: 'Odaberite svoj jezik, a zatim ćemo početi.',
    letsGo: 'Počnimo',
    consentText: `## Dobrodošli!
Ovo nije tipična anketa.  

Ovo je interaktivni AI intervju, dizajniran da čuje vašu jedinstvenu perspektivu.
`,
  },
  bg: {
    firstParagraph: 'Признавам {interviewTerms} и {privacyPolicy}',
    interviewTerms: 'Условия за интервю',
    privacyPolicy: 'Политика за поверителност',
    translatePickLanguage: 'Изберете своя език и след това ще започнем.',
    letsGo: 'Нека започнеме',
    consentText: `## Добре дошли!
Това не е типична анкета.

Това е интерактивно AI интервю, създадено, за да чуе вашата уникална перспектива.
`,
  },
  bn: {
    firstParagraph: 'আমি {interviewTerms} এবং {privacyPolicy} গ্রহণ করি',
    interviewTerms: 'সাক্ষাৎকারের শর্তাবলী',
    privacyPolicy: 'গোপনীয়তা নীতি',
    translatePickLanguage: 'আপনার ভাষা নির্বাচন করুন, তারপর আমরা শুরু করব।',
    letsGo: 'শুরু করা যাক',
    consentText: `## স্বাগতম!
এটি একটি সাধারণ সমীক্ষা নয়।

এটি একটি ইন্টারেক্টিভ AI সাক্ষাৎকার, যা আপনার অনন্য দৃষ্টিভঙ্গি শোনার জন্য ডিজাইন করা হয়েছে।
`,
  },
  yue: {
    firstParagraph: '我接受 {interviewTerms} 同 {privacyPolicy}',
    interviewTerms: '訪談條款',
    privacyPolicy: '私隱政策',
    translatePickLanguage: '揀你嘅語言，然後我哋開始。',
    letsGo: '開始啦',
    consentText: `## 歡迎!
呢個唔係普通嘅問卷。

呢個係互動式 AI 訪談，專為聽取你獨特嘅觀點而設計。
`,
  },
  ca: {
    firstParagraph: 'Accepto {interviewTerms} i {privacyPolicy}',
    interviewTerms: "Termes de l'entrevista",
    privacyPolicy: 'Política de privacitat',
    translatePickLanguage: 'Tria el teu idioma i després començarem.',
    letsGo: 'Comencem',
    consentText: `## Benvingut!
Aquesta no és una enquesta típica.  

És una entrevista interactiva amb IA, dissenyada per escoltar la teva perspectiva única.
`,
  },
  zh: {
    firstParagraph: '我接受{interviewTerms}和{privacyPolicy}',
    interviewTerms: '面试条款',
    privacyPolicy: '隐私政策',
    translatePickLanguage: '选择您的语言，然后我们就开始。',
    letsGo: '让我们开始吧',
    consentText: `## 欢迎！
这不是一项典型的调查。  

这是一次互动式人工智能访谈，旨在倾听你独特的观点。
`,
  },
  hr: {
    firstParagraph: 'Prihvaćam {interviewTerms} i {privacyPolicy}',
    interviewTerms: 'Uslovi intervjua',
    privacyPolicy: 'Politika privatnosti',
    translatePickLanguage: 'Odaberite svoj jezik, a zatim ćemo započeti.',
    letsGo: 'Krenimo',
    consentText: `## Dobrodošli!
Ovo nije tipična anketa.  

Ovo je interaktivni AI intervju, dizajniran da čuje vašu jedinstvenu perspektivu.
`,
  },
  cs: {
    firstParagraph: 'Souhlasím s {interviewTerms} a {privacyPolicy}',
    interviewTerms: 'Podmínky rozhovoru',
    privacyPolicy: 'Zásady ochrany osobních údajů',
    translatePickLanguage: 'Vyberte si svůj jazyk, a pak začneme.',
    letsGo: 'Začněme',
    consentText: `## Vítejte!
Toto není typický průzkum.  

Toto je interaktivní AI rozhovor, navržený tak, aby vyslechl váš jedinečný pohled.
`,
  },
  da: {
    firstParagraph: 'Jeg accepterer {interviewTerms} og {privacyPolicy}',
    interviewTerms: 'Interviewvilkår',
    privacyPolicy: 'Fortrolighedspolitik',
    translatePickLanguage: 'Vælg dit sprog, og så begynder vi.',
    letsGo: 'Lad os begynde',
    consentText: `## Velkommen!
Dette er ikke en typisk undersøgelse.  

Dette er et interaktivt AI-interview, designet til at høre dit unikke perspektiv.
`,
  },
  nl: {
    firstParagraph: 'Ik accepteer {interviewTerms} en {privacyPolicy}',
    interviewTerms: 'Interviewvoorwaarden',
    privacyPolicy: 'Privacybeleid',
    translatePickLanguage: 'Kies je taal en dan beginnen we.',
    letsGo: 'Laten we beginnen',
    consentText: `## Welkom!
Dit is geen typische enquête.  

Dit is een interactieve AI-interview, ontworpen om jouw unieke perspectief te horen.
`,
  },
  en: {
    firstParagraph: 'I accept {interviewTerms} and {privacyPolicy}',
    interviewTerms: 'Interview Terms',
    privacyPolicy: 'Privacy Policy',
    translatePickLanguage: 'Pick your language, and then we’ll begin.',
    letsGo: "Let's go",
    consentText: `## Welcome.
### This isn’t a survey — it’s a conversation.
I'm an AI interviewer that listens like a human. I'll follow your lead, ask questions based on what you say, and help uncover what matters most.

**Here’s how it works:**
- Just talk naturally — use your mic or camera to record your answers
- I’ll ask follow-ups based on your answers
- There’s no time limit, and longer answers help me understand you better

Your honest thoughts make this powerful. Thanks for sharing them.
`,
  },
  et: {
    firstParagraph: 'Ma nõustun {interviewTerms} ja {privacyPolicy}',
    interviewTerms: 'Intervjuu tingimused',
    privacyPolicy: 'Privaatsuspoliitika',
    translatePickLanguage: 'Valige oma keel ja siis alustame.',
    letsGo: 'Alustame',
    consentText: `## Tere tulemast!
See ei ole tavaline küsitlus.  

See on interaktiivne tehisintellekti intervjuu, loodud selleks, et kuulda teie ainulaadset perspektiivi.
`,
  },
  fi: {
    firstParagraph: 'Hyväksyn {interviewTerms} ja {privacyPolicy}',
    interviewTerms: 'Haastatteluehdot',
    privacyPolicy: 'Tietosuojakäytäntö',
    translatePickLanguage: 'Valitse kielesi, niin aloitamme.',
    letsGo: 'Aloitetaan',
    consentText: `## Tervetuloa!
Tämä ei ole tavallinen kysely.  

Tämä on interaktiivinen tekoälyhaastattelu, suunniteltu kuulemaan sinun ainutlaatuinen näkökulmasi.
`,
  },
  fr: {
    firstParagraph: "J'accepte {interviewTerms} et {privacyPolicy}",
    interviewTerms: "Conditions d'entretien",
    privacyPolicy: 'Politique de confidentialité',
    translatePickLanguage: 'Choisissez votre langue, puis nous commencerons.',
    letsGo: 'Commençons',
    consentText: `## Bienvenue !
Ce n’est pas un sondage classique.  

Ceci est un entretien interactif avec une IA, conçu pour écouter votre perspective unique.
`,
  },
  gl: {
    firstParagraph: 'Acepto {interviewTerms} e {privacyPolicy}',
    interviewTerms: 'Termos da entrevista',
    privacyPolicy: 'Política de privacidade',
    translatePickLanguage: 'Escolle o teu idioma e logo comezaremos.',
    letsGo: 'Empecemos',
    consentText: `## Benvido!
Esta non é unha enquisa típica.  

Esta é unha entrevista interactiva con IA, deseñada para escoitar a túa perspectiva única.
`,
  },
  de: {
    firstParagraph: 'Ich akzeptiere {interviewTerms} und {privacyPolicy}',
    interviewTerms: 'Interviewbedingungen',
    privacyPolicy: 'Datenschutzrichtlinie',
    translatePickLanguage: 'Wählen Sie Ihre Sprache, und dann beginnen wir.',
    letsGo: 'Lass uns anfangen',
    consentText: `## Willkommen!
Dies ist keine typische Umfrage.  

Dies ist ein interaktives KI-Interview, das darauf ausgelegt ist, deine einzigartige Perspektive zu hören.
`,
  },
  el: {
    firstParagraph: 'Αποδέχομαι {interviewTerms} και {privacyPolicy}',
    interviewTerms: 'Όροι συνέντευξης',
    privacyPolicy: 'Πολιτική απορρήτου',
    translatePickLanguage: 'Επιλέξτε τη γλώσσα σας και στη συνέχεια θα ξεκινήσουμε.',
    letsGo: 'Ας ξεκινήσουμε',
    consentText: `## Καλώς ήρθατε!
Αυτή δεν είναι μια τυπική έρευνα.  

Πρόκειται για μια διαδραστική συνέντευξη με τεχνητή νοημοσύνη, σχεδιασμένη για να ακούσει τη μοναδική σας οπτική.
`,
  },
  he: {
    firstParagraph: 'אני מקבל {interviewTerms} ו {privacyPolicy}',
    interviewTerms: 'תנאי הראיון',
    privacyPolicy: 'מדיניות פרטיות',
    translatePickLanguage: 'בחר את השפה שלך, ואז נתחיל.',
    letsGo: 'בואו נתחיל',
    consentText: `## ברוכים הבאים!
זו לא סקר רגיל.  

זו ראיון אינטראקטיבי עם בינה מלאכותית, שנועד לשמוע את נקודת המבט הייחודית שלך.
`,
  },
  hi: {
    firstParagraph: 'मैं {interviewTerms} और {privacyPolicy} को स्वीकार करता हूँ',
    interviewTerms: 'साक्षात्कार की शर्तें',
    privacyPolicy: 'गोपनीयता नीति',
    translatePickLanguage: 'अपनी भाषा चुनें, और फिर हम शुरू करेंगे।',
    letsGo: 'आइए शुरू करें',
    consentText: `## स्वागत है!
यह कोई साधारण सर्वेक्षण नहीं है।  

यह एक इंटरैक्टिव एआई इंटरव्यू है, जिसे आपकी अनूठी दृष्टिकोण सुनने के लिए डिज़ाइन किया गया है।
`,
  },
  hu: {
    firstParagraph: 'Elfogadom a(z) {interviewTerms} és {privacyPolicy}',
    interviewTerms: 'Interjú feltételei',
    privacyPolicy: 'Adatvédelmi irányelvek',
    translatePickLanguage: 'Válassza ki a nyelvét, és akkor kezdünk.',
    letsGo: 'Kezdjük',
    consentText: `## Üdvözöljük!
Ez nem egy tipikus felmérés.  

Ez egy interaktív AI-interjú, amelyet az Ön egyedi nézőpontjának meghallgatására terveztek.
`,
  },
  is: {
    firstParagraph: 'Ég samþykki {interviewTerms} og {privacyPolicy}',
    interviewTerms: 'Viðtalskjör',
    privacyPolicy: 'Persónuverndarstefna',
    translatePickLanguage: 'Veldu tungumálið þitt, og þá byrjum við.',
    letsGo: 'Byrjum við',
    consentText: `## Velkomin!
Þetta er ekki hefðbundin könnun.  

Þetta er gagnvirk AI viðtal, hannað til að hlusta á þitt einstaka sjónarhorn.
`,
  },
  id: {
    firstParagraph: 'Saya menerima {interviewTerms} dan {privacyPolicy}',
    interviewTerms: 'Syarat Wawancara',
    privacyPolicy: 'Kebijakan Privasi',
    translatePickLanguage: 'Pilih bahasa Anda, lalu kita akan mulai.',
    letsGo: 'Mari kita mulai',
    consentText: `## Selamat datang!
Ini bukan survei biasa.  

Ini adalah wawancara AI interaktif, dirancang untuk mendengarkan perspektif unik Anda.
`,
  },
  it: {
    firstParagraph: 'Accetto {interviewTerms} e {privacyPolicy}',
    interviewTerms: 'Termini del colloquio',
    privacyPolicy: 'Politica sulla riservatezza',
    translatePickLanguage: 'Scegli la tua lingua e poi inizieremo.',
    letsGo: 'Cominciamo',
    consentText: `## Benvenuto!
Questo non è un sondaggio tipico.  

Questa è un’intervista interattiva con l’IA, progettata per ascoltare la tua prospettiva unica.
`,
  },
  ja: {
    firstParagraph: '私は{interviewTerms}と{privacyPolicy}に同意します',
    interviewTerms: 'インタビューポリシー',
    privacyPolicy: 'プライバシーポリシー',
    translatePickLanguage: '言語を選んでから始めましょう。',
    letsGo: '始めましょう',
    consentText: `## ようこそ！
これは典型的なアンケートではありません。

これは、あなたのユニークな視点を聞くために設計されたインタラクティブなAIインタビューです。
`,
  },
  ka: {
    firstParagraph: 'ვეთანხმები {interviewTerms} და {privacyPolicy}',
    interviewTerms: 'ინტერვიუს პირობები',
    privacyPolicy: 'კონფიდენციალურობის პოლიტიკა',
    translatePickLanguage: 'აირჩიეთ თქვენი ენა და შემდეგ დავიწყებთ.',
    letsGo: 'დავიწყოთ',
    consentText: `## მოგესალმებით!
ეს არ არის ჩვეულებრივი გამოკითხვა.

ეს არის ინტერაქტიული AI ინტერვიუ, რომელიც შექმნილია თქვენი უნიკალური შეხედულების მოსასმენად.
`,
  },
  kn: {
    firstParagraph: 'ನಾನು {interviewTerms} ಮತ್ತು {privacyPolicy} ಒಪ್ಪಿಗೆಯಾದೇನೆ',
    interviewTerms: 'ಮೂಲಕ ನಿಯಮಗಳು',
    privacyPolicy: 'ಗೌಪ್ಯತಾ ನೀತಿ',
    translatePickLanguage: 'ನಿಮ್ಮ ಭಾಷೆಯನ್ನು ಆರಿಸಿ, ನಂತರ ನಾವು ಪ್ರಾರಂಭಿಸುತ್ತೇವೆ.',
    letsGo: 'ಪ್ರಾರಂಭಿಸೋಣ',
    consentText: `## ಸ್ವಾಗತ!
ಇದು ಸಾಮಾನ್ಯ ಸಮೀಕ್ಷೆ ಅಲ್ಲ.  

ಇದು ನಿಮ್ಮ ವಿಶಿಷ್ಟ ದೃಷ್ಟಿಕೋನವನ್ನು ಕೇಳಲು ವಿನ್ಯಾಸಗೊಳಿಸಲಾಗಿರುವ ಇಂಟರ್ಯಾಕ್ಟಿವ್ AI ಸಂದರ್ಶನವಾಗಿದೆ.
`,
  },
  kk: {
    firstParagraph: 'Мен {interviewTerms} және {privacyPolicy} келісемін',
    interviewTerms: 'Сұхбат шарттары',
    privacyPolicy: 'Құпиялылық саясаты',
    translatePickLanguage: 'Тіліңізді таңдаңыз, содан кейін біз бастаймыз.',
    letsGo: 'Бастау',
    consentText: `## Қош келдіңіз!
Бұл кәдімгі сауалнама емес.  

Бұл сіздің ерекше көзқарасыңызды тыңдау үшін жасалған интерактивті ЖИ сұхбаты.
`,
  },
  ko: {
    firstParagraph: '저는 {interviewTerms}와 {privacyPolicy}에 동의합니다',
    interviewTerms: '인터뷰 약관',
    privacyPolicy: '개인정보 처리방침',
    translatePickLanguage: '언어를 선택하면 시작합니다.',
    letsGo: '시작해봅시다',
    consentText: `## 환영합니다!
이것은 일반적인 설문조사가 아닙니다.  

이는 여러분의 독특한 관점을 듣기 위해 설계된 인터랙티브 AI 인터뷰입니다.
`,
  },
  lv: {
    firstParagraph: 'Es piekrītu {interviewTerms} un {privacyPolicy}',
    interviewTerms: 'Intervijas noteikumi',
    privacyPolicy: 'Privātuma politika',
    translatePickLanguage: 'Izvēlieties savu valodu, un tad mēs sāksim.',
    letsGo: 'Sāksim',
    consentText: `## Laipni lūdzam!
  Šis nav parasts aptaujas veids.  
  
  Šī ir interaktīva AI intervija, izveidota, lai dzirdētu jūsu unikālo skatījumu.
  `,
  },
  lt: {
    firstParagraph: 'Aš sutinku su {interviewTerms} ir {privacyPolicy}',
    interviewTerms: 'Interviu sąlygos',
    privacyPolicy: 'Privatumo politika',
    translatePickLanguage: 'Pasirinkite savo kalbą, o tada pradėsime.',
    letsGo: 'Pradėkime',
    consentText: `## Sveiki atvykę!
Tai nėra įprasta apklausa.  

Tai interaktyvus dirbtinio intelekto interviu, skirtas išgirsti jūsų unikalų požiūrį.
`,
  },
  mk: {
    firstParagraph: 'Прифатам {interviewTerms} и {privacyPolicy}',
    interviewTerms: 'Услови за интервју',
    privacyPolicy: 'Политика за приватност',
    translatePickLanguage: 'Изберете го вашиот јазик, а потоа ќе започнеме.',
    letsGo: 'Да започнеме',
    consentText: `## Добредојдовте!
Ова не е типична анкета.  

Ова е интерактивно AI интервју, дизајнирано да го слушне вашиот уникатен поглед.
`,
  },
  ms: {
    firstParagraph: 'Saya terima {interviewTerms} dan {privacyPolicy}',
    interviewTerms: 'Terma Wawancara',
    privacyPolicy: 'Dasar Privasi',
    translatePickLanguage: 'Pilih bahasa anda, dan kemudian kami akan mula.',
    letsGo: 'Mari mula',
    consentText: `## Selamat datang!
Ini bukan tinjauan biasa.  

Ini adalah temu bual AI interaktif, direka untuk mendengar perspektif unik anda.
`,
  },
  mi: {
    firstParagraph: 'Kei te whakaae au ki {interviewTerms} me {privacyPolicy}',
    interviewTerms: 'Ngā tikanga uiui',
    privacyPolicy: 'Ture Tūmataiti',
    translatePickLanguage: 'Tīpakohia tō reo, kātahi ka tīmata tātou.',
    letsGo: 'Tīmataratanga',
    consentText: `## Nau mai!
Ehara tēnei i te rangahau noa.  

He uiui AI pāhekoheko tēnei, i hangaia hei whakarongo ki tō tirohanga ahurei.
`,
  },
  mr: {
    firstParagraph: 'मी {interviewTerms} आणि {privacyPolicy} स्वीकारतो',
    interviewTerms: 'साक्षात्कार अटी',
    privacyPolicy: 'गोपनीयता धोरण',
    translatePickLanguage: 'तुमची भाषा निवडा, आणि मग आपण सुरुवात करू.',
    letsGo: 'आपल्या आरंभा',
    consentText: `## स्वागत आहे!
  हे एखादे साधारण सर्वेक्षण नाही.  
  
  हे एक संवादात्मक AI मुलाखत आहे, जे तुमच्या अनन्य दृष्टिकोनाला ऐकण्यासाठी डिझाइन केले आहे.
  `,
  },
  ne: {
    firstParagraph: 'म माने {interviewTerms} र {privacyPolicy} स्वीकार गर्छु',
    interviewTerms: 'साक्षात्कारका सर्तहरू',
    privacyPolicy: 'गोपनीयता नीति',
    translatePickLanguage: 'तपाईंको भाषा छान्नुहोस्, अनि हामी सुरु गर्नेछौं।',
    letsGo: 'हामी सुरु गरौं',
    consentText: `## स्वागत छ!
  यो सामान्य सर्वेक्षण होइन।  
  
  यो एक अन्तरक्रियात्मक एआई अन्तरवार्ता हो, तपाईंको अद्वितीय दृष्टिकोण सुन्न डिजाइन गरिएको।
  `,
  },
  no: {
    firstParagraph: 'Jeg aksepterer {interviewTerms} og {privacyPolicy}',
    interviewTerms: 'Intervjuforhold',
    privacyPolicy: 'Personvernpolitikk',
    translatePickLanguage: 'Velg språket ditt, og så begynner vi.',
    letsGo: 'La oss begynne',
    consentText: `## Velkommen!
  Dette er ikke en typisk undersøkelse.  
  
  Dette er et interaktivt AI-intervju, designet for å høre ditt unike perspektiv.
  `,
  },
  pa: {
    firstParagraph: 'ਮੈਂ {interviewTerms} ਅਤੇ {privacyPolicy} ਨੂੰ ਸਵੀਕਾਰ ਕਰਦਾ ਹਾਂ',
    interviewTerms: 'ਸাক্ষਾਤਕਾਰ ਦੀਆਂ ਸ਼ਰਤਾਂ',
    privacyPolicy: 'ਪਰਾਈਵੇਟ ਨੀਤੀ',
    translatePickLanguage: 'ਆਪਣੀ ਭਾਸ਼ਾ ਚੁਣੋ, ਅਤੇ ਫਿਰ ਅਸੀਂ ਸ਼ੁਰੂ ਕਰਾਂਗੇ।',
    letsGo: 'ਸ਼ੁਰੂ ਕਰੀਏ',
    consentText: `## ਸੁਆਗਤ ਹੈ!
  ਇਹ ਕੋਈ ਆਮ ਸਰਵੇਖਣ ਨਹੀਂ ਹੈ।  
  
  ਇਹ ਇੱਕ ਇੰਟਰਐਕਟਿਵ ਏਆਈ ਇੰਟਰਵਿਊ ਹੈ, ਜੋ ਤੁਹਾਡੇ ਵਿਲੱਖਣ ਨਜ਼ਰੀਏ ਨੂੰ ਸੁਣਨ ਲਈ ਡਿਜ਼ਾਇਨ ਕੀਤਾ ਗਿਆ ਹੈ।
  `,
  },
  fa: {
    firstParagraph: 'من {interviewTerms} و {privacyPolicy} را می‌پذیرم',
    interviewTerms: 'شرایط مصاحبه',
    privacyPolicy: 'سیاست حفظ حریم خصوصی',
    translatePickLanguage: 'زبان خود را انتخاب کنید، سپس شروع می‌کنیم.',
    letsGo: 'بیا شروع کنیم',
    consentText: `## خوش آمدید!
این یک نظرسنجی معمولی نیست.  

این یک مصاحبه تعاملی با هوش مصنوعی است که برای شنیدن دیدگاه منحصربه‌فرد شما طراحی شده است.
`,
  },
  pl: {
    firstParagraph: 'Akceptuję {interviewTerms} i {privacyPolicy}',
    interviewTerms: 'Warunki rozmowy kwalifikacyjnej',
    privacyPolicy: 'Polityka prywatności',
    translatePickLanguage: 'Wybierz swój język, a następnie zaczniemy.',
    letsGo: 'Zacznijmy',
    consentText: `## Witaj!
To nie jest typowa ankieta.  

To interaktywny wywiad z AI, zaprojektowany, aby usłyszeć Twoją unikalną perspektywę.
`,
  },
  pt: {
    firstParagraph: 'Aceito os {interviewTerms} e a {privacyPolicy}',
    interviewTerms: 'Termos da entrevista',
    privacyPolicy: 'Política de privacidade',
    translatePickLanguage: 'Escolha o seu idioma e depois começaremos.',
    letsGo: 'Vamos começar',
    consentText: `## Bem-vindo.
### Isto não é um inquérito — é uma conversa.
Sou um entrevistador de IA que ouve como uma pessoa. Vou acompanhar o teu ritmo, fazer perguntas com base no que dizes e ajudar-te a descobrir o que é mais importante para ti.

**Vê como funciona:**
- Fala naturalmente — usa o teu microfone ou câmara para gravar as tuas respostas
- Farei perguntas de seguimento com base nas tuas respostas
- Não há limite de tempo, e respostas mais detalhadas ajudam-me a compreender-te melhor

A tua honestidade torna isto valioso. Obrigado por a partilhares.
`,
  },
  ro: {
    firstParagraph: 'Accept {interviewTerms} și {privacyPolicy}',
    interviewTerms: 'Termeni de interviu',
    privacyPolicy: 'Politica de confidențialitate',
    translatePickLanguage: 'Alegeți limba dvs., apoi vom începe.',
    letsGo: 'Să începem',
    consentText: `## Bun venit!
Aceasta nu este un sondaj obișnuit.  

Aceasta este un interviu interactiv cu AI, conceput pentru a asculta perspectiva ta unică.
`,
  },
  ru: {
    firstParagraph: 'Я принимаю {interviewTerms} и {privacyPolicy}',
    interviewTerms: 'Условия собеседования',
    privacyPolicy: 'Политика конфиденциальности',
    translatePickLanguage: 'Выберите ваш язык, а затем мы начнем.',
    letsGo: 'Давайте начнем',
    consentText: `## Добро пожаловать!
Это не обычный опрос.  

Это интерактивное интервью с ИИ, созданное для того, чтобы услышать вашу уникальную точку зрения.
`,
  },
  sr: {
    firstParagraph: 'Прихватам {interviewTerms} и {privacyPolicy}',
    interviewTerms: 'Услови интервјуа',
    privacyPolicy: 'Политика приватности',
    translatePickLanguage: 'Изаберите свој језик, а онда ћемо почети.',
    letsGo: 'Хајде да почнемо',
    consentText: `## Добродошли!
Ово није типична анкета.  

Ово је интерактивни AI интервју, дизајниран да чује вашу јединствену перспективу.
`,
  },
  sk: {
    firstParagraph: 'Súhlasím s {interviewTerms} a {privacyPolicy}',
    interviewTerms: 'Podmienky pohovoru',
    privacyPolicy: 'Zásady ochrany osobných údajov',
    translatePickLanguage: 'Vyberte si svoj jazyk a potom začneme.',
    letsGo: 'Začnime',
    consentText: `## Vitajte!
Toto nie je typický prieskum.  

Toto je interaktívny AI rozhovor, navrhnutý tak, aby vypočul váš jedinečný pohľad.
`,
  },
  sl: {
    firstParagraph: 'Sprejem {interviewTerms} in {privacyPolicy}',
    interviewTerms: 'Pogoji za razgovor',
    privacyPolicy: 'Politika zasebnosti',
    translatePickLanguage: 'Izberite svoj jezik, nato bomo začeli.',
    letsGo: 'Začnimo',
    consentText: `## Dobrodošli!
To ni tipična anketa.  

To je interaktivni AI intervju, zasnovan za poslušanje vaše edinstvene perspektive.
`,
  },
  es: {
    firstParagraph: 'Acepto {interviewTerms} y {privacyPolicy}',
    interviewTerms: 'Términos de entrevista',
    privacyPolicy: 'Política de privacidad',
    translatePickLanguage: 'Elige tu idioma y luego comenzaremos.',
    letsGo: 'Comencemos',
    consentText: `## ¡Bienvenido!
Esta no es una encuesta típica.  

Esta es una entrevista interactiva con IA, diseñada para escuchar tu perspectiva única.
`,
  },
  sw: {
    firstParagraph: 'Ninakubali {interviewTerms} na {privacyPolicy}',
    interviewTerms: 'Masharti ya mahojiano',
    privacyPolicy: 'Sera ya faragha',
    translatePickLanguage: 'Chagua lugha yako, kisha tutaanza.',
    letsGo: 'Tuangalie',
    consentText: `## Karibu!
Hii si uchunguzi wa kawaida.  

Hii ni usaili wa AI unaoshirikisha, ulioundwa kusikiliza mtazamo wako wa kipekee.
`,
  },
  sv: {
    firstParagraph: 'Jag accepterar {interviewTerms} och {privacyPolicy}',
    interviewTerms: 'Intervjuförhållanden',
    privacyPolicy: 'Sekretesspolicy',
    translatePickLanguage: 'Välj ditt språk, och sedan börjar vi.',
    letsGo: 'Låt oss börja',
    consentText: `## Välkommen!
Detta är inte en typisk undersökning.  

Detta är en interaktiv AI-intervju, designad för att höra ditt unika perspektiv.
`,
  },
  tl: {
    firstParagraph: 'Tinanggap ko ang {interviewTerms} at {privacyPolicy}',
    interviewTerms: 'Mga Tuntunin ng Panayam',
    privacyPolicy: 'Patakaran sa Privacy',
    translatePickLanguage: 'Pumili ng wika, at pagkatapos ay magsisimula tayo.',
    letsGo: 'Simulan na natin',
    consentText: `## Maligayang pagdating!
Ito ay hindi karaniwang survey.  

Ito ay isang interactive na AI na panayam, idinisenyo upang pakinggan ang iyong natatanging pananaw.
`,
  },
  ta: {
    firstParagraph: 'நான் {interviewTerms} மற்றும் {privacyPolicy} ஐ ஏற்கிறேன்',
    interviewTerms: 'சந்திப்பு விதிமுறைகள்',
    privacyPolicy: 'தனியுரிமை கொள்கை',
    translatePickLanguage: 'உங்கள் மொழியைத் தேர்ந்தெடுக்கவும், பிறகு நாம் தொடங்குவோம்.',
    letsGo: 'தொடங்கவேண்டும்',
    consentText: `## வரவேற்கிறோம்!
இது ஒரு சாதாரண சர்வே அல்ல.  

இது உங்கள் தனித்துவமான பார்வையை கேட்க உருவாக்கப்பட்ட ஒரு இன்டர்அக்டிவ் AI நேர்காணல்.
`,
  },
  th: {
    firstParagraph: 'ฉันยอมรับ {interviewTerms} และ {privacyPolicy}',
    interviewTerms: 'เงื่อนไขการสัมภาษณ์',
    privacyPolicy: 'นโยบายความเป็นส่วนตัว',
    translatePickLanguage: 'เลือกภาษาของคุณ จากนั้นเราจะเริ่มต้น',
    letsGo: 'เริ่มต้นเถอะ',
    consentText: `## ยินดีต้อนรับ!
นี่ไม่ใช่แบบสอบถามทั่วไป  

นี่คือการสัมภาษณ์ AI แบบโต้ตอบ ซึ่งออกแบบมาเพื่อรับฟังมุมมองที่เป็นเอกลักษณ์ของคุณ
`,
  },
  tr: {
    firstParagraph: 'Ben {interviewTerms} ve {privacyPolicy} kabul ediyorum',
    interviewTerms: 'Mülakat şartları',
    privacyPolicy: 'Gizlilik Politikası',
    translatePickLanguage: 'Dilinizi seçin ve sonra başlayalım.',
    letsGo: 'Başlayalım',
    consentText: `## Hoş geldiniz!
Bu tipik bir anket değil.  

Bu, sizin benzersiz bakış açınızı duymak için tasarlanmış etkileşimli bir AI röportajıdır.
`,
  },
  uk: {
    firstParagraph: 'Я приймаю {interviewTerms} та {privacyPolicy}',
    interviewTerms: 'Умови співбесіди',
    privacyPolicy: 'Політика конфіденційності',
    translatePickLanguage: 'Виберіть свою мову, а тоді ми почнемо.',
    letsGo: 'Давайте почнемо',
    consentText: `## Ласкаво просимо!
Це не типовий опитування.  

Це інтерактивне інтерв’ю з ШІ, створене, щоб почути вашу унікальну точку зору.
`,
  },
  ur: {
    firstParagraph: 'میں {interviewTerms} اور {privacyPolicy} کو قبول کرتا ہوں',
    interviewTerms: 'انٹرویو کی شرائط',
    privacyPolicy: 'رازداری کی پالیسی',
    translatePickLanguage: 'اپنی زبان منتخب کریں، اور پھر ہم شروع کریں گے۔',
    letsGo: 'شروع کرتے ہیں',
    consentText: `## خوش آمدید!
  یہ ایک عام سروے نہیں ہے۔

  یہ ایک انٹرایکٹو AI انٹرویو ہے، جو آپ کے منفرد نقطہ نظر کو سننے کے لیے ڈیزائن کیا گیا ہے۔
  `,
  },
  uz: {
    firstParagraph: 'Men {interviewTerms} va {privacyPolicy}ni qabul qilaman',
    interviewTerms: 'Intervyu shartlari',
    privacyPolicy: 'Maxfiylik siyosati',
    translatePickLanguage: "Tilingizni tanlang, so'ngra boshlaymiz.",
    letsGo: 'Boshlaylik',
    consentText: `## Xush kelibsiz!
Bu oddiy so'rovnoma emas.

Bu sizning noyob fikringizni eshitish uchun mo'ljallangan interaktiv AI intervyu.
`,
  },
  vi: {
    firstParagraph: 'Tôi chấp nhận {interviewTerms} và {privacyPolicy}',
    interviewTerms: 'Điều kiện phỏng vấn',
    privacyPolicy: 'Chính sách bảo mật',
    translatePickLanguage: 'Chọn ngôn ngữ của bạn, sau đó chúng tôi sẽ bắt đầu.',
    letsGo: 'Bắt đầu thôi',
    consentText: `## Chào mừng!
Đây không phải là một khảo sát thông thường.  

Đây là một cuộc phỏng vấn AI tương tác, được thiết kế để lắng nghe quan điểm độc đáo của bạn.
`,
  },
  cy: {
    firstParagraph: 'Derbyniaf {interviewTerms} a {privacyPolicy}',
    interviewTerms: 'Telerau Cyfweliad',
    privacyPolicy: 'Polisi Preifatrwydd',
    translatePickLanguage: 'Dewiswch eich iaith, ac yna byddwn yn dechrau.',
    letsGo: 'Gwnewch yn dechrau',
    consentText: `## Croeso!
Nid arolygon arferol yw hwn.  

Mae hwn yn gyfweliad rhyngweithiol â AI, wedi’i gynllunio i wrando ar eich persbectif unigryw.
`,
  },
};
